import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { showApiErrorToast } from '@/utils/errors';
import { createInstitute, instituteQueryKeys } from '../api/institutes.api';
import type { CreateInstitutePayload } from '../types/institute.types';

export function useCreateInstitute(onSuccess?: () => void) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload: CreateInstitutePayload) => createInstitute(payload),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: instituteQueryKeys.all() });
      toast.success('Institute created successfully');
      onSuccess?.();
    },
    onError: (error) => {
      showApiErrorToast(error, 'Failed to create institute');
    },
  });
}
